<template>
  <div class="mcat-wrapper">
    <div class="mcat-top">
      <b-button
        class="mcat-top-btn"
        @click="$bvModal.show(`add-category`)"
        variant="link"
      >Rename Category</b-button>
      <b-button class="mcat-top-btn" variant="link">
        <b-icon-plus />Add Item
      </b-button>
    </div>
    <div class="cat-title">{{category}}</div>
    <div v-if="items !==null" class="items-wrapper">
      <template v-for="(item,index) in items">
        <ItemCard :key="index" :menuId="menuId" :item="item" :editable="true" />
      </template>
    </div>
    <div class="no-data" v-else>There are no items in this category yet. Click below to add item</div>
  </div>
</template>

<script>
import { BIconPlus } from "bootstrap-vue";
import ItemCard from "../pages/components/ItemCard";
export default {
  props: {},
  components: {
    BIconPlus,
    ItemCard
  },
  data() {
    return {
      category: this.$route.params.category_title,
      menuId: this.$route.params.menuId
    };
  },
  methods: {
    getItems(limit) {
      this.$store.dispatch("Menu/fetchItems", {
        menuId: this.menuId,
        category: this.currentCategory.name,
        limit
      });
    },
    async fetchCategory() {
      return await this.$store.dispatch("Menu/fetchCategory", {
        menuId: this.menuId,
        categoryTitle: this.category
      });
    }
  },
  computed: {
    items() {
      return this.currentCategory === null
        ? null
        : this.$store.state.Menu[this.currentCategory.name];
    },
    currentCategory() {
      return this.$store.state.Menu.currentCategory;
    }
  },
  mounted() {
    this.fetchCategory().then(() => {
      this.getItems(20);
    });
  }
};
</script>

<style scoped>
.mcat-wrapper .mcat-top {
  display: flex;
  justify-content: flex-end;
}
.mcat-wrapper .mcat-top .mcat-top-btn {
  color: #2ca8ff;
  margin: 0;
  padding: 0 10px;
}

.mcat-wrapper .mcat-top .mcat-top-btn:hover {
  color: #2ca8ff;
}

.mcat-wrapper .items-wrapper {
 display: grid;
  grid-template-columns: repeat(auto-fit,minmax(250px,1fr));
  grid-gap: 10px;
}

.mcat-wrapper .cat-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 20px;
  /* identical to box height, or 111% */

  color: #000000;
  margin-bottom: 25px;
}
</style>